import React, { useState, useEffect } from 'react';

const Notification = ({ message, type, duration = 3000, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      if (onClose) onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  if (!isVisible) return null;

  const getStyles = () => {
    const baseStyles = {
      position: 'fixed',
      top: '20px',
      right: '20px',
      padding: '16px 24px',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      zIndex: 10000,
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      fontSize: '15px',
      fontWeight: '500',
      animation: 'slideIn 0.3s ease-out',
      minWidth: '300px',
      maxWidth: '500px'
    };

    const typeStyles = {
      success: {
        background: 'linear-gradient(135deg, #48bb78 0%, #38a169 100%)',
        color: '#ffffff',
        border: '1px solid #38a169'
      },
      error: {
        background: 'linear-gradient(135deg, #f56565 0%, #e53e3e 100%)',
        color: '#ffffff',
        border: '1px solid #e53e3e'
      },
      warning: {
        background: 'linear-gradient(135deg, #ed8936 0%, #d69e2e 100%)',
        color: '#ffffff',
        border: '1px solid #d69e2e'
      },
      info: {
        background: 'linear-gradient(135deg, #4299e1 0%, #3182ce 100%)',
        color: '#ffffff',
        border: '1px solid #3182ce'
      }
    };

    return { ...baseStyles, ...typeStyles[type] };
  };

  const getIcon = () => {
    const icons = {
      success: '✅',
      error: '❌',
      warning: '⚠️',
      info: 'ℹ️'
    };
    return icons[type] || '📢';
  };

  return (
    <>
      <style>
        {`
          @keyframes slideIn {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
        `}
      </style>
      <div style={getStyles()}>
        <span style={{ fontSize: '18px' }}>{getIcon()}</span>
        <span>{message}</span>
        <button
          onClick={() => {
            setIsVisible(false);
            if (onClose) onClose();
          }}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'inherit',
            fontSize: '18px',
            cursor: 'pointer',
            marginLeft: 'auto',
            padding: '0 4px',
            opacity: '0.7',
            transition: 'opacity 0.2s ease'
          }}
          onMouseEnter={(e) => e.target.style.opacity = '1'}
          onMouseLeave={(e) => e.target.style.opacity = '0.7'}
        >
          ×
        </button>
      </div>
    </>
  );
};

export default Notification;